module.exports = require("./gsw");